// components/tasks/WorkflowRenderer.js
import React from 'react';
import TaskGroup from './TaskGroup.js';
import { WorkflowEngine } from '../../services/workflowEngine.js';

const WorkflowRenderer = ({
  projectType,
  completedTaskIds,
  taskStates,
  onTaskToggle,
  pendingChanges,
  isAdmin
}) => {
  const tasksByGroup = WorkflowEngine.getTasksByGroup(projectType, completedTaskIds, taskStates);
  const groups = WorkflowEngine.getWorkflowGroups(projectType);

  const leftColumnGroups = groups.filter(g => g.layout === 'left-column');
  const rightColumnGroups = groups.filter(g => g.layout === 'right-column');
  const fullWidthGroups = groups.filter(g => g.layout === 'full-width');

  return (
    <div className="field-stack">
      {(leftColumnGroups.length > 0 || rightColumnGroups.length > 0) && (
        <div className="task-columns">
          <div className="task-column">
            {leftColumnGroups.map(group => (
              <TaskGroup
                key={group.name}
                groupName={group.name}
                groupConfig={group}
                tasks={tasksByGroup[group.name]?.tasks || []}
                onTaskToggle={onTaskToggle}
                pendingChanges={pendingChanges}
                isAdmin={isAdmin}
              />
            ))}
          </div>
          <div className="task-column">
            {rightColumnGroups.map(group => (
              <TaskGroup
                key={group.name}
                groupName={group.name}
                groupConfig={group}
                tasks={tasksByGroup[group.name]?.tasks || []}
                onTaskToggle={onTaskToggle}
                pendingChanges={pendingChanges}
                isAdmin={isAdmin}
              />
            ))}
          </div>
        </div>
      )}

      {fullWidthGroups.map(group => (
        <TaskGroup
          key={group.name}
          groupName={group.name}
          groupConfig={group}
          tasks={tasksByGroup[group.name]?.tasks || []}
          onTaskToggle={onTaskToggle}
          pendingChanges={pendingChanges}
          isAdmin={isAdmin}
        />
      ))}
    </div>
  );
};

export default WorkflowRenderer;
